export default "__VITE_ASSET__Dgsxs7dX__"